import React, { useEffect } from "react";
import GPAC from "../images/corner/corner-gpac.webp";
import { renderStrapiContent } from "../utils/contentfulOptions";
import FullPageLoader from "../components/FullPageLoader";
import StrapiImage from "../components/StrapiImage";

const PrivateEvents = ({ info }) => {
  useEffect(() => {
    document.title = "Auburn Road - Private Events";
    return () => {
      document.title = "Auburn Road Vineyards";
    };
  }, []);

  useEffect(() => {
    const existingScript = document.querySelector(
      'script[src="https://d1vpukrd9uvxxk.cloudfront.net/includes/js/plugins/iframesizer.js"]'
    );
    if (existingScript) return;

    const script = document.createElement("script");
    script.src =
      "https://d1vpukrd9uvxxk.cloudfront.net/includes/js/plugins/iframesizer.js";
    script.type = "text/javascript";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  if (!info) {
    return <FullPageLoader />;
  }

  const images = info.image || [];
  const [leadImage, ...galleryImages] = images;

  return (
    <>
      <img className="corner-gpac" src={GPAC} alt="" />
      <div className="container content-page p-t-100">
        <section className="content-hero">
          <p className="content-hero__kicker">Gatherings at the vineyard</p>
          <h1 className="huge-text-no-quote content-hero__title">
            Private Events
          </h1>
          <p className="content-hero__intro">
            Host your celebration, rehearsal dinner, or corporate gathering
            among the vines, with Auburn Road hospitality throughout.
          </p>
        </section>

        <section className="content-story">
          {leadImage && (
            <div className="content-story__media">
              <img
                className="content-story__photo"
                src={StrapiImage(leadImage, "large")}
                alt={leadImage.alternativeText || leadImage.Title || ""}
              />
            </div>
          )}
          <div className="content-story__copy">
            {renderStrapiContent(info?.Content)}
          </div>
        </section>

        {galleryImages.length > 0 && (
          <div className="content-gallery">
            {galleryImages.map((img, index) => (
              <img
                key={img.id || index}
                className="content-gallery__photo"
                src={StrapiImage(img, "large")}
                alt={img.alternativeText || img.Title || ""}
              />
            ))}
          </div>
        )}

        <section className="content-section">
          <h2 className="content-section__heading">Tell us about your event</h2>
          <div className="content-media">
            <iframe
              id="iframe"
              title="Private Events Interest Form"
              src="https://app2.planningpod.com/index.cfm?fuseaction=leads.interestForm&ssid=eyJWRVJTSU9OIjoiZW1iZWQiLCJVVUlEIjoiRDdFNDVGQkQtRkI1Ny00OEMwLUJGQzI2RTg4RDdDQjQ1MUQifQ=="
              width="100%"
              height="900"
              frameBorder="0"
            />
          </div>
        </section>
      </div>
    </>
  );
};

export default PrivateEvents;
